/* eslint-disable custom-rules/ban-ethereum-eth-terms */
import { assertPackageVersion } from '@dynamic-labs-sdk/assert-package-version';

import {
  name as packageName,
  version as packageVersion,
} from '../../package.json';
assertPackageVersion(packageName, packageVersion);

export { addStarknetExtension } from '../addStarknetExtension';
export { NotStarknetProviderError } from '../errors/NotStarknetProviderError';
export { getStarknetAccount } from '../getStarknetAccount';
export { isStarknetNetworkProvider } from '../isStarknetNetworkProvider';
export { isStarknetWalletAccount } from '../isStarknetWalletAccount';
export type { StarknetNetworkProvider } from '../StarknetNetworkProvider.types';
export type { StarknetWalletAccount } from '../StarknetWalletAccount.types';

export {
  ETH_CONTRACT_ABI,
  ETH_STARKNET_ADDRESS,
  WEI_PER_ETH,
} from '../utils/constants';
